module.exports = __webpack_public_path__ + "img/varvara-desktop.83f7d9e3.jpg";